var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-icon',{attrs:{"small":"","color":_vm.status == 1?'warning':_vm.status == 2?'success':'error'}},[_vm._v(" "+_vm._s(_vm.status == 1? _vm.icons.mdiEmailAlertOutline:_vm.status == 2?_vm.icons.mdiEmailOpenOutline:_vm.icons.mdiClose)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }